import type { ClinicalIconProps } from "./shared";
import { ClinicalIconSvg, FillPath, StrokePath } from "./shared";

export function IconCrownOnImplant(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <FillPath d="M6 13.2v-3.36a6 3.84 0 0 1 12 0v3.36z" />
      <StrokePath d="M12 13.2v8.2M10.2 14.8h3.6M10.2 16.8h3.6M10.7 18.8h2.6" />
    </ClinicalIconSvg>
  );
}

export function IconBridgeOnImplant(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M1.5 13.2v-1.96a3.5 2.24 0 0 1 7 0v1.96zM8.5 13.2v-1.96a3.5 2.24 0 0 1 7 0v1.96zM15.5 13.2v-1.96a3.5 2.24 0 0 1 7 0v1.96z" />
      <StrokePath d="M5 13.2v7.2M3.2 14.8h3.6M3.2 16.8h3.6M3.7 18.8h2.6" />
      <StrokePath d="M19 13.2v7.2M17.2 14.8h3.6M17.2 16.8h3.6M17.7 18.8h2.6" />
    </ClinicalIconSvg>
  );
}

export function IconAllOn46(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M1 11v-1.54a2.75 1.76 0 0 1 5.5 0v1.54zM6.5 11v-1.54a2.75 1.76 0 0 1 5.5 0v1.54zM12 11v-1.54a2.75 1.76 0 0 1 5.5 0v1.54zM17.5 11v-1.54a2.75 1.76 0 0 1 5.5 0v1.54zM1 11h22" />
      <StrokePath d="M3.75 11v6.2M1.95 12.6h3.6M1.95 14.6h3.6M2.45 16.6h2.6" />
      <StrokePath d="M9.25 11v6.2M7.45 12.6h3.6M7.45 14.6h3.6M7.95 16.6h2.6" />
      <StrokePath d="M14.75 11v6.2M12.95 12.6h3.6M12.95 14.6h3.6M13.45 16.6h2.6" />
      <StrokePath d="M20.25 11v6.2M18.45 12.6h3.6M18.45 14.6h3.6M18.95 16.6h2.6" />
    </ClinicalIconSvg>
  );
}

export function IconImplantOverdenture(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <g transform="translate(0 -1.6)">
        <StrokePath d="M0.8 17.3v3.5a1.5 1.5 0 0 0 1.1 1.4c1.4 0.4 4.4 1.1 10.2 1.1s8.8-0.6 10.2-1.1a1.5 1.5 0 0 0 1.0-1.4v-3.5" />
        <StrokePath d="M5.3 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
        <StrokePath d="M9.8 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
        <StrokePath d="M14.3 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
        <StrokePath d="M18.8 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
        <StrokePath d="M23.3 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
      </g>
      <StrokePath d="M8.6 8.4v3.6M15.4 8.4v3.6" />
      <FillPath d="M8.6 8.4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 1 0 0 3ZM15.4 8.4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 1 0 0 3Z" />
    </ClinicalIconSvg>
  );
}
